export default __webpack_public_path__ + "static/media/ct213.9f1add3d.png";